import React from 'react';

import cn from 'classnames';
import { Paragraph } from '../Paragraph';

import * as styles from './styles.module.css';

export function WarningBanner({
  icon,
  text,
  variant = 'regular',
  className,
  style,
  size = 'medium',
  balanceText = true,
}: {
  icon?: React.ReactNode;
  text: React.ReactNode;
  variant?: 'regular' | 'info' | 'critical';
  className?: string;
  style?: React.CSSProperties;
  size?: React.ComponentProps<typeof Paragraph>['size'];
  balanceText?: boolean;
}) {
  return (
    <div className={cn(styles.warningBanner, styles[variant], className)} style={style}>
      {icon ? <div className={styles.icon}>{icon}</div> : null}
      <Paragraph className={balanceText ? styles.balanceText : ''} size={size}>
        {text}
      </Paragraph>
    </div>
  );
}
